var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2 8.9998C16.2 12.9763 12.9765 16.1998 9.00005 16.1998C5.0236 16.1998 1.80005 12.9763 1.80005 8.9998C1.80005 5.02335 5.0236 1.7998 9.00005 1.7998C12.9765 1.7998 16.2 5.02335 16.2 8.9998ZM9.00006 6.2998C8.66807 6.2998 8.37689 6.4791 8.21991 6.75046C7.97103 7.18071 7.42047 7.32774 6.99022 7.07885C6.55996 6.82996 6.41294 6.27941 6.66182 5.84915C7.12731 5.04447 7.99955 4.4998 9.00006 4.4998C10.4912 4.4998 11.7001 5.70864 11.7001 7.1998C11.7001 8.3754 10.9487 9.37552 9.90006 9.74617V9.89981C9.90006 10.3969 9.49712 10.7998 9.00006 10.7998C8.50301 10.7998 8.10006 10.3969 8.10006 9.89981V8.9998C8.10006 8.50275 8.50301 8.0998 9.00006 8.0998C9.49712 8.0998 9.90006 7.69686 9.90006 7.1998C9.90006 6.70275 9.49712 6.2998 9.00006 6.2998ZM9.00005 13.4998C9.49711 13.4998 9.90005 13.0969 9.90005 12.5998C9.90005 12.1027 9.49711 11.6998 9.00005 11.6998C8.50299 11.6998 8.10005 12.1027 8.10005 12.5998C8.10005 13.0969 8.50299 13.4998 9.00005 13.4998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.653e34d2c4fe4fb0fbb0b06a7d063eb2.svg";
export { ForwardRef as ReactComponent };